import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <footer className="footer">
      <div className='footer__container container'>
        <h1 className='footer__title'>MattGaviria.</h1>

        <ul className='footer__list'>

          <li>
            <a href="#education" className='footer__link'>Education</a>
          </li>

          <li>
            <a href="#portfolio" className='footer__link'>Portfolio</a>
          </li>

          <li>
            <a href="#skills" className='footer__link'>Skills</a>
          </li>

          
        </ul>  

        <div className="footer__social">
        <a href="https://github.com/MattGaviria" className="footer__social-link" target="_blank" rel="noopener noreferrer">
            <i className="uil uil-github"></i>
        </a>

        <a href="https://www.linkedin.com/in/cmateogaviria/" className="footer__social-link" target="_blank" rel="noopener noreferrer">
            <i className="uil uil-linkedin"></i>
            
        </a>

        <a href="https://www.instagram.com/mattgaviria/" className="footer__social-link" target="_blank" rel="noopener noreferrer">
            <i className="uil uil-instagram"></i>
            
        </a>
          
        </div>

        <span className="footer__copy"> MattGavira. All rights reserved </span>
      </div> 
    </footer>
  );
};

export default Footer;